import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/salaries"; // Matches your backend route in server.ts

// Fetch Salaries
export const fetchSalaries = createAsyncThunk("salaries/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("API Response:", response.data);
  return response.data;
});

// Add Salary
export const addSalary = createAsyncThunk("salaries/add", async (salaryData) => {
  const response = await hrmsPostRequest(API_URL, salaryData);
  return response.data;
});

// Update Salary
export const updateSalary = createAsyncThunk("salaries/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

// Delete Salary
export const deleteSalary = createAsyncThunk("salaries/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

const salarySlice = createSlice({
  name: "salaries",
  initialState: {
    salaries: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalaries.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSalaries.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.salaries = action.payload;
      })
      .addCase(fetchSalaries.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addSalary.fulfilled, (state, action) => {
        state.salaries.push(action.payload);
      })
      .addCase(updateSalary.fulfilled, (state, action) => {
        const index = state.salaries.findIndex((s) => s.id === action.payload.id);
        if (index !== -1) {
          state.salaries[index] = action.payload;
        }
      })
      .addCase(deleteSalary.fulfilled, (state, action) => {
        state.salaries = state.salaries.filter((s) => s.id !== action.payload);
      });
  },
});

export default salarySlice.reducer;